module.exports = __webpack_public_path__ + "static/media/55_000049.e7f19805.jpg";